// extracted by mini-css-extract-plugin
module.exports = {"root":"OpenButton_root__BpqY9"};